// Application constants

export const APP_NAME = 'Amazon Connect - Live Demo';

export const CAROUSEL_AUTO_ROTATE_INTERVAL = 3000; // 3 seconds

export const QUEUE_POLL_INTERVAL = 2000; // 2 seconds (fallback if WebSocket fails)

export const WEBSOCKET_HEARTBEAT_INTERVAL = 30000; // 30 seconds

export const WEBSOCKET_RECONNECT_DELAYS = [1000, 2000, 4000, 8000, 16000, 30000]; // Exponential backoff

export const CALL_WARNING_THRESHOLD = 0.9; // Show warning at 90% of max duration

export const SESSION_ID_PREFIX = 'session-';

// Generate unique session ID
export function generateSessionId(): string {
  return `${SESSION_ID_PREFIX}${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
}

// Debug mode - enabled via ?debug=true query parameter
export function isDebug(): boolean {
  return typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('debug');
}

// Debug logger - only logs when ?debug=true
export const debug = {
  log: (...args: unknown[]) => { if (isDebug()) console.log(...args); },
  warn: (...args: unknown[]) => { if (isDebug()) console.warn(...args); },
};
